import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class, extend, fetch2 } from '../utils';
import Searcher from './Searcher';
import Icons from '../resources/icons'; //noinspection JSCommentMatchesSignature,JSCommentMatchesSignature

/**
 *
 * @class Searches gst geoservice (http://www.kortforsyningen.dk/dokumentation/geonoeglergeosearch)
 * @extends Septima.Search.Searcher
 * @constructs Septima.Search.GeoSearch
 * @param {Object} options GeoSearch expects these properties:
 * @param options.area {string} "muncode" + municipalitycode eg.; "muncode0151"
 * @param options.targets {string[]} List of targets to search. The full list is ['kommuner', 'matrikelnumre', 'opstillingskredse', 'politikredse', 'postdistrikter', 'regioner', 'retskredse']
 * @param options.authParams {Object} Either {ticket: 'ttttt'}, where t is a ticket issued by kortforsyningen or {login: 'lll', password: 'pppp'}
 *
 * @example
 * var geoSearchOptions = {
 *     onSelect : function(result) {
 *          log('<b>'+ result.data.type + ':</b> '+ result.title + '<br/>');
 *     },
 *     area: "muncode0151",
 *     targets : ['kommuner'],
 *     authParams: {
 *      login: 'xxxx',
 *      password: 'xxxxxx'
 *     },
 *     matchesPhrase: "Begynder med ",
 *     searchDelay: 200
 * };
 * searchers.push(new Septima.Search.GeoSearch(geoSearchOptions));
 *
 */

export default Class(Searcher,
/**  @lends Septima.Search.GeoSearch# */
{
  serviceUrl: 'https://kortforsyningen.kms.dk',
  geoTypes: [{
    resource: 'matrikelnumre',
    returnType: "matrikelnummer",
    singular: 'Matrikelnummer',
    plural: 'Matrikelnumre'
  }, {
    resource: 'kommuner',
    returnType: "kommune",
    singular: 'Kommune',
    plural: 'Kommuner'
  }, {
    resource: 'opstillingskredse',
    returnType: "opstillingskreds",
    singular: 'Opstillingskreds',
    plural: 'Opstillingskredse'
  }, {
    resource: 'politikredse',
    returnType: "politikreds",
    singular: 'Politikreds',
    plural: 'Politikredse'
  }, {
    resource: 'postdistrikter',
    returnType: "postdistrikt",
    singular: 'Postdistrikt',
    plural: 'Postdistrikter'
  }, {
    resource: 'regioner',
    returnType: "region",
    singular: 'Region',
    plural: 'Regioner'
  }, {
    resource: 'retskredse',
    returnType: "retskreds",
    singular: 'Retskreds',
    plural: 'Retskredse'
  }, {
    resource: 'sogne',
    returnType: "sogn",
    singular: 'Sogn',
    plural: 'Sogne'
  }],
  initialize: function initialize(options) {
    options.usesGeoFunctions = true;
    if (!options.source) options.source = "Kortforsyningen";
    this.source = options.source;
    options.usesGeoFunctions = true;
    this.Searcher(options);
    this.area = null;

    if (options.kommunekode) {
      var municipalities = options.kommunekode.split(' ');

      for (var i = 0; i < municipalities.length; i++) {
        municipalities[i] = "muncode0" + municipalities[i];
      }

      this.area = municipalities.join();
    } else if (options.area) {
      this.area = options.area;
    }

    this.authParams = options.authParams;
    this.myTypes = [];
    if (!options.targets) options.targets = [];
    var resources = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = options.targets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var target = _step.value;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this.geoTypes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var type = _step2.value;

            if (type.resource === target || target === '*') {
              this.myTypes.push(type);
              resources.push(type.resource);
              this.registerType(this.source, {
                id: type.resource,
                singular: type.singular,
                plural: type.plural
              });
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    this.resourcesParam = resources.join(',');
    this.iconURI = Icons.searchers.geoSearch.result;
  },
  fetchData: function () {
    var _fetchData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(query, caller) {
      var callParams, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = query.type;
              _context.next = _context.t0 === 'collapse' ? 3 : _context.t0 === 'cut' ? 5 : _context.t0 === 'no-cut' ? 5 : _context.t0 === 'list' ? 5 : 18;
              break;

            case 3:
              caller.fetchSuccess(this.createQueryResultFromResources());
              return _context.abrupt("break", 18);

            case 5:
              callParams = this.createCallParams(query);
              if (query.isBlank) callParams.search = "a b c d e f g h i j k l m n o p q r s t u v x y z æ ø å 0 1 2 3 4 5 6 7 8 9";
              _context.prev = 7;
              _context.next = 10;
              return this.callGeoSearch(callParams);

            case 10:
              data = _context.sent;
              data.query = query;
              caller.fetchSuccess(this.parseResult(data.data, query));
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t1 = _context["catch"](7);
              caller.fetchError(this, _context.t1);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[7, 15]]);
    }));

    function fetchData(_x, _x2) {
      return _fetchData.apply(this, arguments);
    }

    return fetchData;
  }(),
  createQueryResultFromResources: function createQueryResultFromResources() {
    var queryResult = this.createQueryResult();
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = this.myTypes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var type = _step3.value;
        queryResult.addNewQuery(this.source, type.resource, type.plural, null, "", null, null);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return queryResult;
  },
  createCallParams: function createCallParams(query) {
    var params = {};
    var type = this.getTypeFromQuery(query);

    if (type === null) {
      params.limit = (query.limit + 2) * this.myTypes.length;
      if (params.limit > 100) params.limit = 100;
      params.resources = this.resourcesParam;
    } else {
      params.limit = query.limit + 1;
      params.resources = type.resource;
    }

    if (this.area) params.area = this.area;
    params.search = query.queryString;
    return params;
  },
  callGeoSearch: function () {
    var _callGeoSearch = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(params) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetch2(this.serviceUrl + '/Geosearch?service=GEO', {
                data: extend(params, this.authParams)
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function callGeoSearch(_x3) {
      return _callGeoSearch.apply(this, arguments);
    }

    return callGeoSearch;
  }(),
  getTypeFromQuery: function getTypeFromQuery(query) {
    if (query.hasTarget && this.hasType(query.target.type)) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.myTypes[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var type = _step4.value;
          if (query.target.type.toLowerCase() === type.resource.toLowerCase()) return type;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }

    return null;
  },
  getTypeFromReturnType: function getTypeFromReturnType(returnType) {
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = this.geoTypes[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var type = _step5.value;
        if (returnType === type.returnType) return type;
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    return null;
  },
  parseResult: function parseResult(data, query) {
    var queryResult = this.createQueryResult();
    var resultTypes = [];

    if (data !== null) {
      this.fixHits(data);
      var nextTypeIndex = 0;

      while (nextTypeIndex > -1 && nextTypeIndex < data.length) {
        resultTypes.push(data[nextTypeIndex].type);
        nextTypeIndex = this.procesTypeFromIndex(data, nextTypeIndex, query, queryResult);
      }
    }

    if (!query.hasTarget && !query.isBlank) {
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.myTypes[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var thisType = _step6.value;

          if (thisType.plural.toLowerCase().indexOf(query.queryString.toLowerCase()) === 0) {
            var foundInResultTypes = false;
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
              for (var _iterator7 = resultTypes[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var thisResultType = _step7.value;
                if (thisType.returnType === thisResultType) foundInResultTypes = true;
              }
            } catch (err) {
              _didIteratorError7 = true;
              _iteratorError7 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                  _iterator7.return();
                }
              } finally {
                if (_didIteratorError7) {
                  throw _iteratorError7;
                }
              }
            }

            if (!foundInResultTypes) queryResult.addNewQuery(this.source, thisType.resource, thisType.plural, null, "", null, null);
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    }

    return queryResult;
  },
  fixHits: function fixHits(hits) {
    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
      for (var _iterator8 = hits[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
        var hit = _step8.value;

        switch (hit.type) {
          case "matrikelnummer":
            hit.presentationString = hit.matrnr + ", " + hit.elavsnavn;
            break;

          case "opstillingskreds":
            hit.descriptionString = hit.storkredsNavn + "s storkreds";
            break;

          case "postdistrikt":
            hit.presentationString = hit.id + " " + hit.name;
            break;
        }
      }
    } catch (err) {
      _didIteratorError8 = true;
      _iteratorError8 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
          _iterator8.return();
        }
      } finally {
        if (_didIteratorError8) {
          throw _iteratorError8;
        }
      }
    }
  },
  procesTypeFromIndex: function procesTypeFromIndex(data, fromIndex, query, queryResult) {
    if (fromIndex < 0 || fromIndex >= data.length) return -1;
    var index = fromIndex;
    var returnType = data[index].type;
    var typeHits = [];

    while (index < data.length && data[index].type === returnType) {
      typeHits.push(data[index]);
      index++;
    }

    var type = this.getTypeFromReturnType(returnType);
    var count = typeHits.length;
    var hitsShown = count === 1 ? 1 : query.type === 'no-cut' && count > query.limit ? 0 : Math.min(count, query.limit);
    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      for (var _iterator9 = typeHits.slice(0, hitsShown)[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        var thisHit = _step9.value;
        this.addResultFromHit(queryResult, thisHit, type.resource);
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }

    if (count > hitsShown && ["no-cut", "cut"].indexOf(query.type) !== -1) queryResult.addNewQuery(this.source, type.resource, type.plural, null, query.queryString, null, null);
    return index;
  },
  addResultFromHit: function addResultFromHit(queryResult, thisHit, typeId) {
    var resultGeometry;
    if (thisHit.hasOwnProperty("geometryWkt_detail")) resultGeometry = this.translateWktToGeoJsonObject(thisHit.geometryWkt_detail);else resultGeometry = this.translateWktToGeoJsonObject(thisHit.geometryWkt);
    var result = queryResult.addResult(this.source, typeId, thisHit.presentationString, thisHit.descriptionString ? thisHit.descriptionString : null, resultGeometry, thisHit);

    switch (thisHit.type) {
      case "matrikelnummer":
        result.isComplete = false;
        result.id = thisHit.elavskode + '-' + thisHit.matrnr;
        break;

      case "kommune":
        result.id = thisHit.id;
        break;

      case "opstillingskreds":
        result.id = thisHit.id;
        break;

      case "politikreds":
        result.id = thisHit.id;
        break;

      case "postdistrikt":
        result.id = thisHit.id;
        break;

      case "retskreds":
        result.id = thisHit.id;
        break;

      case "sogn":
        result.id = thisHit.id;
        break;
    }
  },
  geoKeys: function () {
    var _geoKeys = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(method, params) {
      var data, properties, geometry, wkt, hit, ejd, _ejd;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetch2(this.serviceUrl + '?servicename=RestGeokeys_v2&method=' + method + '&f=json&geometry=true', {
                data: Object.assign({
                  hits: 1
                }, params, this.authParams)
              });

            case 2:
              data = _context3.sent;

              if (!(data.features && data.features.length > 0)) {
                _context3.next = 32;
                break;
              }

              properties = data.features[0].properties;
              geometry = data.features[0].geometry;
              wkt = this.translateGeoJsonObjectToWkt(geometry);
              _context3.t0 = method;
              _context3.next = _context3.t0 === "matrikelnr" ? 10 : _context3.t0 === "esrejendom" ? 15 : _context3.t0 === "kommune" ? 17 : _context3.t0 === "opstillingskreds" ? 19 : _context3.t0 === "politikreds" ? 21 : _context3.t0 === "postdistrikt" ? 23 : _context3.t0 === "retskreds" ? 25 : _context3.t0 === "sogn" ? 27 : 29;
              break;

            case 10:
              _context3.next = 12;
              return this.geoKeys("esrejendom", {
                ejkode: properties.ejerlav_kode,
                matnr: properties.matnr
              });

            case 12:
              ejd = _context3.sent;
              hit = {
                "type": "matrikelnummer",
                "elavsnavn": properties.ejerlav_navn,
                "elavskode": properties.ejerlav_kode,
                "matrnr": properties.matnr,
                "presentationString": properties.matnr + ', ' + properties.ejerlav_navn,
                "centroid_x": properties.centroid_x,
                "centroid_y": properties.centroid_y,
                "geometryWkt": wkt,
                "geometryWkt_detail": wkt,
                "esrejdnr": ejd.esrejdnr,
                "sfeejdnr": ejd.sfeejdnr
              };
              return _context3.abrupt("break", 29);

            case 15:
              _ejd = {
                "esrejdnr": properties.esrejdnr,
                "sfeejdnr": properties.sfeejendom_sfeejdnr
              };
              return _context3.abrupt("return", _ejd);

            case 17:
              hit = {
                "type": "kommune",
                "id": properties.kode,
                "name": properties.navn,
                "presentationString": properties.navn + ' kommune (' + properties.kode + ')',
                "geometryWkt": wkt,
                "geometryWkt_detail": wkt
              };
              return _context3.abrupt("break", 29);

            case 19:
              hit = {
                "type": "opstillingskreds",
                "id": properties.kode,
                "name": properties.navn,
                "presentationString": properties.navn + "kredsen",
                "geometryWkt": wkt,
                "geometryWkt_detail": wkt,
                "valgkredsNr": properties.valgkreds_nummer,
                "storkredsNr": "",
                "storkredsNavn": properties.storkreds,
                "landsdelsNr": "",
                "landsdelsNavn": properties.landsdel,
                "descriptionString": properties.storkreds + " storkreds"
              };
              return _context3.abrupt("break", 29);

            case 21:
              hit = {
                "type": "politikreds",
                "id": properties.kode,
                "name": properties.navn,
                "presentationString": properties.navn + "kreds",
                "geometryWkt": wkt,
                "geometryWkt_detail": wkt,
                "myndighedsKode": properties.CPR_NR
              };
              return _context3.abrupt("break", 29);

            case 23:
              hit = {
                "type": "postdistrikt",
                "id": properties.kode,
                "name": properties.navn,
                "presentationString": properties.kode + ' ' + properties.navn,
                "geometryWkt": wkt,
                "geometryWkt_detail": wkt
              };
              return _context3.abrupt("break", 29);

            case 25:
              hit = {
                "type": "retskreds",
                "id": properties.kode,
                "name": properties.navn,
                "presentationString": properties.navn,
                "geometryWkt": wkt,
                "geometryWkt_detail": wkt,
                "myndighedsKode": properties.retskreds_kode
              };
              return _context3.abrupt("break", 29);

            case 27:
              hit = {
                "type": "sogn",
                "id": properties.kode,
                "name": properties.navn,
                "presentationString": properties.navn,
                "geometryWkt": wkt,
                "geometryWkt_detail": wkt
              };
              return _context3.abrupt("break", 29);

            case 29:
              return _context3.abrupt("return", {
                hit: hit,
                geometry: geometry
              });

            case 32:
              throw new Error("No " + method + " with " + JSON.stringify(params));

            case 33:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function geoKeys(_x4, _x5) {
      return _geoKeys.apply(this, arguments);
    }

    return geoKeys;
  }(),
  sq: function () {
    var _sq = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(query) {
      var queryResult, querywkt, geom, x, y, result, geop, _ref, mat, geometry, _ref2, kom, _geometry, _ref3, ok, _geometry2, _ref4, pk, _geometry3, _ref5, rk, _geometry4;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              queryResult = this.createQueryResult();

              if (!query.wkt) {
                _context4.next = 52;
                break;
              }

              querywkt = query.wkt;
              geom = this.translateWktToGeoJsonObject(querywkt);
              x = geom.coordinates[0];
              y = geom.coordinates[1];
              geop = {
                geop: "" + x + "," + y
              };

              if (!(this.resourcesParam.indexOf("matrikelnumre") > -1)) {
                _context4.next = 16;
                break;
              }

              _context4.next = 10;
              return this.geoKeys("matrikelnr", geop);

            case 10:
              _ref = _context4.sent;
              mat = _ref.hit;
              geometry = _ref.geometry;
              result = queryResult.addResult(this.source, "matrikelnumre", mat.presentationString, null, geometry, mat);
              result.id = mat.elavskode + '-' + mat.matrnr;
              result.distance = 0;

            case 16:
              if (!(this.resourcesParam.indexOf("kommuner") > -1)) {
                _context4.next = 25;
                break;
              }

              _context4.next = 19;
              return this.geoKeys("kommune", geop);

            case 19:
              _ref2 = _context4.sent;
              kom = _ref2.hit;
              _geometry = _ref2.geometry;
              result = queryResult.addResult(this.source, "kommuner", kom.presentationString, null, _geometry, kom);
              result.id = kom.id;
              result.distance = 0;

            case 25:
              if (!(this.resourcesParam.indexOf("opstillingskredse") > -1)) {
                _context4.next = 34;
                break;
              }

              _context4.next = 28;
              return this.geoKeys("opstillingskreds", geop);

            case 28:
              _ref3 = _context4.sent;
              ok = _ref3.hit;
              _geometry2 = _ref3.geometry;
              result = queryResult.addResult(this.source, "opstillingskredse", ok.presentationString, ok.descriptionString, _geometry2, ok);
              result.id = ok.id;
              result.distance = 0;

            case 34:
              if (!(this.resourcesParam.indexOf("politikredse") > -1)) {
                _context4.next = 43;
                break;
              }

              _context4.next = 37;
              return this.geoKeys("politikreds", geop);

            case 37:
              _ref4 = _context4.sent;
              pk = _ref4.hit;
              _geometry3 = _ref4.geometry;
              result = queryResult.addResult(this.source, "politikredse", pk.presentationString, null, _geometry3, pk);
              result.id = pk.id;
              result.distance = 0;

            case 43:
              if (!(this.resourcesParam.indexOf("retskredse") > -1)) {
                _context4.next = 52;
                break;
              }

              _context4.next = 46;
              return this.geoKeys("retskreds", geop);

            case 46:
              _ref5 = _context4.sent;
              rk = _ref5.hit;
              _geometry4 = _ref5.geometry;
              result = queryResult.addResult(this.source, "retskredse", rk.presentationString, null, _geometry4, rk);
              result.id = rk.id;
              result.distance = 0;

            case 52:
              return _context4.abrupt("return", queryResult);

            case 53:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function sq(_x6) {
      return _sq.apply(this, arguments);
    }

    return sq;
  }(),
  get: function () {
    var _get = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5(id, typeId) {
      var queryResult, result, idents, _ref6, mat, geometry, _ref7, kom, _geometry5, _ref8, ok, _geometry6, _ref9, pk, _geometry7, _ref10, p, _geometry8, _ref11, rk, _geometry9, _ref12, s, _geometry10;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryResult = this.createQueryResult();
              _context5.t0 = typeId;
              _context5.next = _context5.t0 === "matrikelnumre" ? 4 : _context5.t0 === "kommuner" ? 13 : _context5.t0 === "opstillingskredse" ? 21 : _context5.t0 === "politikredse" ? 29 : _context5.t0 === "postdistrikter" ? 37 : _context5.t0 === "retskredse" ? 45 : _context5.t0 === "sogne" ? 53 : 61;
              break;

            case 4:
              idents = id.split('-');
              _context5.next = 7;
              return this.geoKeys("matrikelnr", {
                ejkode: idents[0],
                matnr: idents[1]
              });

            case 7:
              _ref6 = _context5.sent;
              mat = _ref6.hit;
              geometry = _ref6.geometry;
              result = queryResult.addResult(this.source, "matrikelnumre", mat.presentationString, null, geometry, mat);
              result.id = mat.elavskode + '-' + mat.matrnr;
              return _context5.abrupt("break", 61);

            case 13:
              _context5.next = 15;
              return this.geoKeys("kommune", {
                "komkode": id
              });

            case 15:
              _ref7 = _context5.sent;
              kom = _ref7.hit;
              _geometry5 = _ref7.geometry;
              result = queryResult.addResult(this.source, "kommuner", kom.presentationString, null, _geometry5, kom);
              result.id = id;
              return _context5.abrupt("break", 61);

            case 21:
              _context5.next = 23;
              return this.geoKeys("opstillingskreds", {
                "opstnr": id
              });

            case 23:
              _ref8 = _context5.sent;
              ok = _ref8.hit;
              _geometry6 = _ref8.geometry;
              result = queryResult.addResult(this.source, "opstillingskredse", ok.presentationString, ok.descriptionString, _geometry6, ok);
              result.id = id;
              return _context5.abrupt("break", 61);

            case 29:
              _context5.next = 31;
              return this.geoKeys("politikreds", {
                "polkredsnr": id
              });

            case 31:
              _ref9 = _context5.sent;
              pk = _ref9.hit;
              _geometry7 = _ref9.geometry;
              result = queryResult.addResult(this.source, "politikredse", pk.presentationString, null, _geometry7, pk);
              result.id = id;
              return _context5.abrupt("break", 61);

            case 37:
              _context5.next = 39;
              return this.geoKeys("postdistrikt", {
                "postnr": id
              });

            case 39:
              _ref10 = _context5.sent;
              p = _ref10.hit;
              _geometry8 = _ref10.geometry;
              result = queryResult.addResult(this.source, "postdistrikter", p.presentationString, null, _geometry8, p);
              result.id = id;
              return _context5.abrupt("break", 61);

            case 45:
              _context5.next = 47;
              return this.geoKeys("retskreds", {
                "retskredsnr": id
              });

            case 47:
              _ref11 = _context5.sent;
              rk = _ref11.hit;
              _geometry9 = _ref11.geometry;
              result = queryResult.addResult(this.source, "retskredse", rk.presentationString, null, _geometry9, rk);
              result.id = id;
              return _context5.abrupt("break", 61);

            case 53:
              _context5.next = 55;
              return this.geoKeys("sogn", {
                "sognkode": id
              });

            case 55:
              _ref12 = _context5.sent;
              s = _ref12.hit;
              _geometry10 = _ref12.geometry;
              result = queryResult.addResult(this.source, "sogne", s.presentationString, null, _geometry10, s);
              result.id = id;
              return _context5.abrupt("break", 61);

            case 61:
              return _context5.abrupt("return", result);

            case 62:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function get(_x7, _x8) {
      return _get.apply(this, arguments);
    }

    return get;
  }(),
  completeResult: function () {
    var _completeResult = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee7(result) {
      var _this = this;

      var trueGeometryPromise;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!result.isComplete) {
                _context7.next = 4;
                break;
              }

              return _context7.abrupt("return", result);

            case 4:
              result.isComplete = true;

              if (!(result.data.type === "matrikelnummer")) {
                _context7.next = 12;
                break;
              }

              trueGeometryPromise = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee6() {
                var idents, _ref14, mat, geometry;

                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        idents = result.id.split('-');
                        _context6.next = 3;
                        return _this.geoKeys("matrikelnr", {
                          ejkode: idents[0],
                          matnr: idents[1]
                        });

                      case 3:
                        _ref14 = _context6.sent;
                        mat = _ref14.hit;
                        geometry = _ref14.geometry;
                        result.geometry = geometry;
                        result.data.esrejdnr = mat.esrejdnr;
                        result.data.sfeejdnr = mat.sfeejdnr;

                      case 9:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              }))();
              _context7.next = 9;
              return Promise.all([trueGeometryPromise]);

            case 9:
              return _context7.abrupt("return", result);

            case 12:
              return _context7.abrupt("return", result);

            case 13:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function completeResult(_x9) {
      return _completeResult.apply(this, arguments);
    }

    return completeResult;
  }(),
  onSelect_delete: function onSelect_delete(result) {
    if (result.isNewQuery()) {
      if (result.data && result.data.type && result.data.type === 'streetNameType') this._onSelectCallback(result);
    } else {
      this._onSelectCallback(result);
    }
  },
  CLASS_NAME: 'Septima.Search.GeoSearch'
});